import { render, staticRenderFns } from "./PaymentStart.vue?vue&type=template&id=47b627f8&scoped=true"
import script from "./PaymentStart.vue?vue&type=script&lang=js"
export * from "./PaymentStart.vue?vue&type=script&lang=js"
import style0 from "./PaymentStart.vue?vue&type=style&index=0&id=47b627f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b627f8",
  null
  
)

export default component.exports